/* eslint-disable */
function validateContact(email, phone) {
    const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // const phonePattern = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/;
    const phonePattern = /^\+7\([0-9]{3}\)[0-9]{3}-[0-9]{2}-[0-9]{2}$/i;
    const matchEmail = email.match(emailPattern);
    const matchPhone = phone.match(phonePattern);
    let isValidate;
    if (email.length > 0 && phone.length > 0) {
        isValidate = matchEmail && matchPhone ? true : false;
    } else {
        isValidate = matchEmail || matchPhone ? true : false;
    }
    return isValidate;
}
/* eslint-enable */

export default validateContact;
